import FeedbackQueue from './FeedbackQueue'

class FeedbackQueueDispatcher {
    constructor() {
        this.queues = {}
        this.inteval = null
        this.milliseconds = 2000
    }

    start() {
        this.interval = setInterval(() => {
            // Keep current queue map to prevent no more items are pushed to them
            const oldQueue = this.queues

            // Assign a new queue map
            this.queues = {}

            // For every queue, execute their callback
            Object.values(oldQueue).forEach((queue) => {
                queue.call()
            })
        }, this.milliseconds)
    }

    stop() {
        if (this.interval) {
            clearInterval(this.interval)
        }
    }

    /**
     * Push an item to a queue, for it to await until its callback is executed
     * @param {String} id Queue id
     * @param {Function} callback Callback assigned to this queue
     * @param {*} item Item to enqueue
     */
    push(id, callback, item) {
        if (!this.queues[id]) {
            this.queues[id] = new FeedbackQueue(id, callback)
        }

        this.queues[id].push(item)
    }
}

export default FeedbackQueueDispatcher
